import QardAgreement from "../../../../assets/pdf/AkadQard.pdf";
import IjarohAgreement from "../../../../assets/pdf/AkadIjaroh.pdf";
import { Checkbox, FormControlLabel } from "@mui/material";

const TnCForm = ({ isAgree, setIsAgree, isIjarohPage }) => {
  return (
    <div className="text-[12px]">
      <div className="mb-4">
        {!isIjarohPage ? (
          <div>
            <embed
              src={QardAgreement}
              width="100%"
              height="375"
              type="application/pdf"
              className="mb-4"
            />
            <FormControlLabel
              control={<Checkbox value={isAgree.qard} />}
              checked={isAgree.qard}
              onChange={() => {
                setIsAgree((prevVal) => ({
                  ...prevVal,
                  qard: !prevVal.qard,
                }));
              }}
              label="Saya sudah membaca dan menyetujui ketentuan “Akad Qard”"
            />
          </div>
        ) : (
          <div>
            <embed
              src={IjarohAgreement}
              width="100%"
              height="375"
              type="application/pdf"
              className="mb-4"
            />
            <FormControlLabel
              control={<Checkbox value={isAgree.ijaroh} />}
              checked={isAgree.ijaroh}
              onChange={() => {
                setIsAgree((prevVal) => ({
                  ...prevVal,
                  ijaroh: !prevVal.ijaroh,
                }));
              }}
              label="Saya sudah membaca dan menyetujui ketentuan “Akad Ijaroh"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TnCForm;
